module.exports = __webpack_public_path__ + "static/media/cape-verde.5c9e3233.svg";